import Vue from 'vue';

export default {
  install: function() {
    Vue.prototype.$imprimirRelatorio = function(rotaRelatorio, id, rotaLista) {
      let mensagem = '';
      let configuracao = this.$storage.configuracao;

      if (configuracao.mensagemAlertaCoordenadorLiberarSolicitacao) {
        if (configuracao.usoEmailLiberarSolicitacao) {
          mensagem = `Você (ou o responsável por liberar as solicitações desse projeto) receberá um email solicitando
                      a confirmação dessa solicitação. É necessário clicar no link indicado no email para que a
                      solicitação seja confirmada, e a fundação prossiga com tramites internos.<br>`
        } else {
          mensagem = `Você (ou o responsável por liberar as solicitações desse projeto) precisa acessar o site e ir no
                      menu de “liberar solicitações” para que a solicitação seja liberada, e a fundação prossiga com
                      tramites internos.<br>`;
        }
      }

      this.$swal({
        title: '',
        html: `
          Solicitação salva com sucesso. <br>
          ${mensagem}
          Deseja visualizar o relatório da solicitação?
        `,
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        allowOutsideClick: false,
        allowEscapeKey: false,
        
      })
      .then(() => {
          this.$router.push({ name: rotaRelatorio, params: { id: id } });
      }, dismiss => {
        if (dismiss === 'cancel') {
          this.$router.push({ name: rotaLista });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/plugins/mensagem-imprimir-relatorio.js